import useLazySelector from "common/redux/useLazySelector";
import { ContractColumnConfigurations, mobileColumns } from "./ContractListColumns";
import { loadContractColumnConfigurations } from "./contracts.actions";

export default function useContractColumns(useMobileColumns: boolean): ContractColumnConfigurations {
    if (useMobileColumns) return mobileColumns;
    
    return useLazySelector(store => store.contractColumnConfigurations, loadContractColumnConfigurations);
}